import { useTranslation } from 'react-i18next';
import ResizeObserver from 'resize-observer-polyfill';

import type { API } from '@/api';
import { useDateTimeFormat } from '@/hooks/useDateTimeFormat';

import 'simplebar';
import 'simplebar/dist/simplebar.css';

window.ResizeObserver = ResizeObserver;

type TimeSlot = API['GET']['ShowerTimeSlots']['response']['time_slots'][number];

interface GroupedTimeSlot {
  date: string;
  hours: Array<{
    hour: string;
    slots: TimeSlot[];
  }>;
}

interface TimeSlotPickerProps {
  groupedTimeSlots: GroupedTimeSlot[];
  onTimeSelect: (datetime: string) => void;
}

/**
 * 時間スロット選択UIコンポーネント
 */
export const TimeSlotPicker = ({
  groupedTimeSlots,
  onTimeSelect,
}: TimeSlotPickerProps) => {
  const { t } = useTranslation();
  const { formatDateWithWeekday, formatHourLabel } = useDateTimeFormat();

  return (
    <div
      className="f2__time-picker-section"
      data-simplebar
      data-simplebar-auto-hide="false"
    >
      <form className="f2__time-picker">
        <div className="f2__time-picker-viewport" tabIndex={0}>
          {groupedTimeSlots.map((dateGroup, dateIndex) => (
            <fieldset key={dateGroup.date} className="f2__day">
              <legend className="f2__legend">
                <div className="f2__instruction">
                  {dateIndex === 0
                    ? t('shareDevice.timeSelection.instruction')
                    : ''}
                </div>
                <div className="f2__date">
                  {formatDateWithWeekday(dateGroup.date)}
                </div>
              </legend>
              <div className="f2__list">
                {dateGroup.hours.map((hourGroup) => (
                  <div key={hourGroup.hour} className="f2__group">
                    <div className="f2__group-label">
                      {formatHourLabel(Number(hourGroup.hour), true)}
                    </div>
                    <div className="f2__group-bt">
                      {hourGroup.slots.map((slot) => {
                        const isDisplayable = slot.displayable !== false;
                        return (
                          <button
                            key={slot.time}
                            className={`f2__slot ${
                              !isDisplayable
                                ? 'f2__slot--hidden'
                                : slot.available
                                  ? 'f2__slot--available'
                                  : 'f2__slot--unavailable'
                            }`}
                            type="button"
                            disabled={!slot.available}
                            onClick={() =>
                              slot.available && onTimeSelect(slot.datetime)
                            }
                            style={
                              !isDisplayable
                                ? { visibility: 'hidden' }
                                : undefined
                            }
                          >
                            {slot.time}
                          </button>
                        );
                      })}
                    </div>
                  </div>
                ))}
              </div>
            </fieldset>
          ))}
        </div>
      </form>
    </div>
  );
};
